import { FC, useEffect, useState } from "react";
import { Box, Typography } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { useStyles } from "../style";
import { updateDaFeedbackReport } from "actions/daFeedbackActions";
import { useDispatch } from "react-redux";
import { useNav } from "hooks/useNav";
import { ModalWindow } from "components/templateComponents/modalWindow";
import { SubmitDaFeedbackDialog } from "components/modals/modalContent/SubmitDaFeedbackDialog";
import { TIME_ZONE } from "constants/constants";
import moment from "moment";
import { DaFeedbackCurrentReport } from "types/DaFeedback";

interface PropsType {
  currentReport: DaFeedbackCurrentReport | null;
}

export const DailyShiftAttenanceStatus: FC<PropsType> = ({ currentReport }) => {
  const classes = useStyles();

  const expiredCondition =
    TIME_ZONE.hour() > 17 || moment().isBefore(moment(currentReport?.created));

  return (
    <>
      {currentReport?.is_submitted && (
        <Alert severity="success" className={classes.alertColor}>
          Status has been submitted
        </Alert>
      )}
      {!currentReport?.is_submitted && expiredCondition ? (
        <Alert severity="warning" className={classes.warningColor}>
          Expired
        </Alert>
      ) : null}
    </>
  );
};

export const SelectShiftAttenance: FC<PropsType> = ({ currentReport }) => {
  const { id } = useNav().pageParams;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [attendanceStatus, setAttendanceStatus] = useState<number>(
    currentReport?.schedule_content?.attendance_status || 0,
  );

  useEffect(() => {
    setAttendanceStatus(currentReport?.schedule_content?.attendance_status)
  }, [currentReport?.schedule_content?.attendance_status])

  const submitDates = () => {
    dispatch(
      updateDaFeedbackReport({
        id,
        type: currentReport?.type,
        data: attendanceStatus,
      }),
    );
  };

  const expiredCondition =
    TIME_ZONE.hour() > 17 || moment().isBefore(moment(currentReport?.created));

  return (
    <Box>
      <Box className={classes.buttonBox}>
        <Box
          onClick={() => setAttendanceStatus(!attendanceStatus || attendanceStatus > 1 ? 1 : 0)}
          className={`${classes.dateBox} ${attendanceStatus === 1 ? classes.activeDateBox : ""} ${currentReport?.is_submitted || expiredCondition ? classes.disabled : ""}`}
        >
          <Typography>Yes</Typography>
        </Box>
        <Box
          onClick={() => setAttendanceStatus(!attendanceStatus || attendanceStatus === 1 ? 2 : 0)}
          className={`${classes.dateBox} ${attendanceStatus === 2 ? classes.activeDateBox : ""} ${currentReport?.is_submitted || expiredCondition ? classes.disabled : ""}`}
        >
          <Typography>No</Typography>
        </Box>
      </Box>
      <Box>
        <ModalWindow
          buttonType={"text"}
          modal_name={"submit-daily-attendance-status"}
          modalTitle={"Submit Attendance Status"}
          buttonText={"Submit Status"}
          modalDescription={"Submit chosen status?"}
          isDisabled={currentReport?.is_submitted || expiredCondition}
        >
          <SubmitDaFeedbackDialog onSubmit={submitDates} />
        </ModalWindow>
      </Box>
    </Box>
  );
};
